
import { Component, OnInit, Inject, HostListener, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { saveAs } from 'file-saver';
import { HttpService } from 'src/app/service/http/http.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { HttpClient } from '@angular/common/http';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
@Component({
  selector: 'app-offerletterview',
  templateUrl: './offerletterview.component.html',
  styleUrls: ['./offerletterview.component.scss'],
})
export class OfferletterviewComponent  implements OnInit {
  [x: string]: any;
  employeeName: any;
  userId: any;
  letterUrl: SafeResourceUrl | null = null;
 
  currentIndex: number = 0;
  incrementLetterData: any[] = [];
  fileName: any='';
loggedInUserCompanyID:any

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private config: Config, private httpService: HttpService,
    private sanitizer: DomSanitizer, private loader: LoaderService, private httpClient: HttpClient, private encryptionService: EncryptionService, public mobileResponsiveService: MobileResponsiveService,
    private dialogRef: MatDialogRef<OfferletterviewComponent>) { }

  ngOnInit() {
    this.employeeName = this.data.userName;
    this.userId = this.data.userId;
    this.fileName = this.data.fileName
    this.incrementLetterData = this.data.incrementLetterData;
    this.currentIndex = this.incrementLetterData.findIndex(employee => employee.inputId === this.userId);
 this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.employeeName && this.userId) {
      // this.viewIncrementLetter();
      this.viewOfferLetter();
    }
  }
 
 

  viewOfferLetter() {
   
    if (this.fileName) {
        // let fileUrl = `http://192.168.0.19:8085/api/uplodphoto/downloadFile/${encodeURIComponent(this.fileName)}`;
        let fileUrl = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${this.fileName}`;
        console.log("Generated File URL:", fileUrl);
  
        this.httpClient.get(fileUrl, { responseType: 'blob' }).subscribe(blob => {
            const blobUrl = URL.createObjectURL(blob);
            this.letterUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
        }, error => {
            console.error("Error loading PDF:", error);
        });
    }
  }

  onClickDownloadLetter() {
    if (this.fileName) {
      // Open the document in a new tab
     let fileUrl = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${this.fileName}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }
}
